import { IMenu } from '../../../redux/initState/InterfacesState';
import { EnumUrlsPages } from '../../../services/Enum';

export const AddMenu: IMenu[] = [
  { text: 'Города доставки Dalli', link: EnumUrlsPages.deliveryFiliali },
  { text: 'Интеграция', link: EnumUrlsPages.integration },
  { text: 'Частые вопросы', link: EnumUrlsPages.questions },
  { text: 'Документы', link: EnumUrlsPages.docs },
  { text: 'Партнеры', link: EnumUrlsPages.partners}
];
